class HTTPError extends Error {
  constructor(status, statusText) {
    super(`HTTP Error: ${status}`);
    this.status = status;
  }
}

const BONUS_LABEL_MAPPING = {
  AnnouncementDate: 'Announcement Date',
  BonusDate: 'Bonus Date',
  BonusRatio: 'Ratio',
};

const SPLITS_LABEL_MAPPING = {
  SplitDate: 'Split Date',
  FVBefore: 'Before FV',
  FVAfter: 'After FV',
  SplitRatio: 'Ratio',
};

const RIGHTS_LABEL_MAPPING = {
  RightDate: 'Ex - Right',
  premium: 'Premium',
  RightsRatio: 'Ratio',
};

const LABEL_MAPPINGS = {
  BONUS: BONUS_LABEL_MAPPING,
  SPLITS: SPLITS_LABEL_MAPPING,
  RIGHTS: RIGHTS_LABEL_MAPPING,
};

function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

function setCookie(name, value, days = 1) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
  window.location.reload(true);
}

function formatDateString(dateStr) {
  const date = new Date(dateStr);
  if (!isNaN(date)) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }
  return dateStr;
}

async function trigger_sentry_error(error_message, error_stack) {
  const csrftoken = getCookie('csrftoken');
  await fetch(`${window.location.origin}/capture-error/`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
    },
    body: JSON.stringify({
      error: error_message,
      error_stack: error_stack,
    }),
  });
}

const updateIndicesExchange = async (exchange, companyName) => {
  setCookie(`indices-${companyName}-currentExchange`, exchange);
};

function updateAllIndicesExchange(exchange) {
  const nseContainer = document.getElementById('nse-indices-container');
  const bseContainer = document.getElementById('bse-indices-container');
  nseContainer.style.display = 'none';
  bseContainer.style.display = 'none';
  if (exchange === 'nse') {
    nseContainer.style.display = 'block';
  } else if (exchange === 'bse') {
    bseContainer.style.display = 'block';
  }
}

function mapKeys(data, mapping_obj) {
  const abc = Object.fromEntries(
    Object.entries(data)
      .filter(([key]) => mapping_obj.hasOwnProperty(key))
      .map(([key, value]) => [
        mapping_obj[key] || key,
        typeof value === 'string' && !isNaN(Date.parse(value))
          ? formatDateString(value)
          : value,
      ]),
  );
  return abc;
}

function initializePagination(
  containerId,
  rowSelector,
  pageButtonSelector,
  prevBtnId,
  nextBtnId,
  prevSpanId,
  nextSpanId,
) {
  const rows = document.querySelectorAll(rowSelector);
  const pageButtons = document.querySelectorAll(pageButtonSelector);
  const prevBtn = document.getElementById(prevBtnId);
  const nextBtn = document.getElementById(nextBtnId);
  const prevBtnSpan = document.getElementById(prevSpanId);
  const nextBtnSpan = document.getElementById(nextSpanId);
  function showPage(pageNo) {
    rows.forEach((row) => (row.style.display = 'none'));
    rows.forEach((row) => {
      if (row.id == `${containerId}page-${pageNo}`) {
        row.style.display = 'table-row';
      }
    });
    const totalRows = rows.length;
    const itemsPerPage = 10;
    const totalPages = Math.ceil(totalRows / itemsPerPage);
    const maxButtons = 10;
    let batchStart = Math.min(
      Math.max(1, pageNo - Math.floor(maxButtons / 2)),
      totalPages - maxButtons + 1,
    );
    if (batchStart <= 0) {
      batchStart = 1;
    }
    const batchEnd = Math.min(totalPages, batchStart + 9);
    pageButtons.forEach((button, index) => {
      const newPageNo = batchStart + index;
      if (newPageNo <= batchEnd) {
        button.style.display = '';
        button.dataset.page = newPageNo;
        button.textContent = newPageNo;
        button.classList.toggle('active', newPageNo === pageNo);
      } else {
        button.style.display = 'none';
      }
    });

    prevBtn.disabled = pageNo === 1;
    nextBtn.disabled = pageNo === pageButtons.length;
    prevBtnSpan.classList.toggle('disabled', pageNo === 1);
    nextBtnSpan.classList.toggle('disabled', pageNo === pageButtons.length);
  }

  pageButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selectedPage = parseInt(button.dataset.page);
      showPage(selectedPage);
    });
  });

  prevBtn.addEventListener('click', () => {
    const currentPage = parseInt(
      document.querySelector(`${pageButtonSelector}.active`).dataset.page,
    );
    if (currentPage > 1) showPage(currentPage - 1);
  });

  nextBtn.addEventListener('click', () => {
    const currentPage = parseInt(
      document.querySelector(`${pageButtonSelector}.active`).dataset.page,
    );
    if (currentPage < pageButtons.length) showPage(currentPage + 1);
  });

  showPage(1);
}

function init() {
  initializePagination(
    'constituents',
    '#constituents-container-body .table-body-row',
    '.pagination .constituents-page-button',
    'constituents-prev-btn',
    'constituents-next-btn',
    'constituents-prev-span',
    'constituents-next-span',
  );

  initializePagination(
    'nse-indices',
    '#nse-indices-container-body .table-body-row',
    '.pagination .nse-indices-page-button',
    'nse-indices-prev-btn',
    'nse-indices-next-btn',
    'nse-indices-prev-span',
    'nse-indices-next-span',
  );

  initializePagination(
    'bse-indices',
    '#bse-indices-container-body .table-body-row',
    '.pagination .bse-indices-page-button',
    'bse-indices-prev-btn',
    'bse-indices-next-btn',
    'bse-indices-prev-span',
    'bse-indices-next-span',
  );
  const nseButtons = document.querySelectorAll('.nse-btn');
  const bseButtons = document.querySelectorAll('.bse-btn');
  nseButtons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const companyName = btn.getAttribute('data-companyName');
      updateIndicesExchange('nse', companyName);
    });
  });
  bseButtons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const companyName = btn.getAttribute('data-companyName');
      updateIndicesExchange('bse', companyName);
    });
  });
  const indicesNseButtons = document.getElementById('nse-btn-indices');
  const indicesBseButtons = document.getElementById('bse-btn-indices');
  updateAllIndicesExchange('nse');
  if (indicesNseButtons) {
    indicesNseButtons.addEventListener('click', async () => {
      indicesBseButtons.classList.remove('active');
      indicesNseButtons.classList.add('active');
      updateAllIndicesExchange('nse');
    });
  }
  if (indicesBseButtons) {
    indicesBseButtons.addEventListener('click', async () => {
      indicesNseButtons.classList.remove('active');
      indicesBseButtons.classList.add('active');
      updateAllIndicesExchange('bse');
    });
  }
}

document.addEventListener('DOMContentLoaded', init());
